import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h-1v5h1","key":"svg-0"}],["path",{"d":"M14 12h1v5h-1","key":"svg-1"}],["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-2"}],["path",{"d":"M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z","key":"svg-3"}]]

const IconFileCode2 = createReactComponent('outline', 'file-code-2', 'FileCode2', __iconNode);

export default IconFileCode2;